// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"191":"c43f0a23","392":"e807e557","749":"2c698dee","895":"5d7f89f5"}[chunkId] + ".css";
};